import { ChangeLayerFunction, LayerChangeMode } from "@/components/canvas/extensions/layerManagerExtension";
import { ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon } from "lucide-react";
import { BlockSection } from "./BlockSection";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Block } from "./Block";
import { useTranslation } from "react-i18next";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

type Props = {
  handleLayerChange: ChangeLayerFunction;
};

export const LayerOption: React.FC<Props> = ({ handleLayerChange }) => {
  const { t } = useTranslation();
  const withTooltip = (trigger: React.ReactNode, tooltipText: string) => {
    return (
      <Tooltip>
        <TooltipTrigger>{trigger}</TooltipTrigger>
        <TooltipContent>{tooltipText}</TooltipContent>
      </Tooltip>
    );
  };

  return (
    <Block title={t("template.inspector.layer")}>
      <BlockSection title={t("template.inspector.layer")}>
        <ToggleGroup
          type="single"
          onValueChange={(value) => handleLayerChange(value as LayerChangeMode)}
          className="justify-start"
        >
          <ToggleGroupItem value="sendToBack">
            {withTooltip(<ChevronsLeftIcon />, t("template.inspector.sendToBack"))}
          </ToggleGroupItem>
          <ToggleGroupItem value="sendBackwards">
            {withTooltip(<ChevronLeftIcon />, t("template.inspector.sendBackwards"))}
          </ToggleGroupItem>
          <ToggleGroupItem value="bringForward">
            {withTooltip(<ChevronRightIcon />, t("template.inspector.bringForward"))}
          </ToggleGroupItem>
          <ToggleGroupItem value="bringToFront">
            {withTooltip(<ChevronsRightIcon />, t("template.inspector.bringToFront"))}
          </ToggleGroupItem>
        </ToggleGroup>
      </BlockSection>
    </Block>
  );
};
